export const getDefaultMedicationObj = () => {
  return {
    adherence: undefined,
    amount: undefined,
    benefits: undefined,
    date: undefined,
    dosage: "",
    med_changes: "ADD",
    medication_name: "",
    side_effect: undefined,
  };
};
